// import { useLocation, useNavigate } from 'react-router-dom'
// import bannerImg from '../Assets/Assests/view-futuristic-robot-school-environment 2.png'
// import Navbar from './Navbar'
// import { FaArrowLeft, FaCoins } from 'react-icons/fa'
// import { useEffect, useState } from 'react'

// const Course = () => {
//   const navigate = useNavigate()
//   const location = useLocation()
//   const course = location.state?.section || {}

//   const [showFullContent, setShowFullContent] = useState(false)
//   const content = course.content || 'No content available.'
//   const previewLength = 500

//   const toggleContent = () => setShowFullContent(!showFullContent)
//   const handleBack = () => navigate(-1)

//   useEffect(() => {
//     // Disable Print Screen Key
//     const handleKeyDown = (event) => {
//       if (event.key === 'PrintScreen') {
//         event.preventDefault()
//         alert('Screenshots are disabled on this page.')
//       }
//       if (event.ctrlKey && (event.key === 'u' || event.key === 's')) {
//         event.preventDefault()
//         alert('This action is disabled.')
//       }
//     }

//     // Disable Right Click
//     const handleContextMenu = (event) => event.preventDefault()

//     document.addEventListener('keydown', handleKeyDown)
//     document.addEventListener('contextmenu', handleContextMenu)

//     return () => {
//       document.removeEventListener('keydown', handleKeyDown)
//       document.removeEventListener('contextmenu', handleContextMenu)
//     }
//   }, [])

//   return (
//     <>
//       <Navbar />

//       <div className='container py-4'>
//         <button
//           className='btn btn-outline-secondary rounded-pill d-inline-flex align-items-center mb-4 px-4'
//           onClick={handleBack}
//         >
//           <FaArrowLeft className='me-2' /> Back
//         </button>

//         <div className='row g-4'>
//           {/* Main Content Column */}

//           <div className='card border-0 shadow-sm'>
//             <div className='card-body p-4'>
//               {/* Video Thumbnail Section */}
//               <div className='position-relative mb-4'>
//                 <img
//                   src={
//                     course.path
//                       ? `https://testaiglobal.tdtlworld.com${course.path}`
//                       : '/default-image.jpg'
//                   }
//                   alt={course.sections}
//                   className='img-fluid rounded-3 w-100'
//                   style={{ maxHeight: '400px', objectFit: 'cover' }}
//                 />

//                 <div className='d-flex justify-content-between align-items-center mb-4'>
//                   <h1 className='h3 mt-3 mb-3'>
//                     {course.sections || 'Course Title'}
//                   </h1>
//                   <span>
//                     <FaCoins
//                       className='text-warning me-2'
//                       size={window.innerWidth < 576 ? 20 : 24}
//                     />
//                     {course.points} Points
//                   </span>
//                 </div>
//               </div>

//               {/* Podcast Section */}
//               {course.audio_path && (
//                 <div className='bg-white p-3 rounded-3 border shadow-sm mb-4'>
//                   <h5 className='text-primary'>Listen to the Podcast</h5>
//                   <audio controls className='w-100'>
//                     <source
//                       src={`https://testaiglobal.tdtlworld.com${course.audio_path}`}
//                       type='audio/mpeg'
//                     />
//                     Your browser does not support the audio element.
//                   </audio>
//                 </div>
//               )}

//               {/* Course Content */}
//               <div
//                 className='bg-light p-4 rounded-3 border border-danger'
//                 onCopy={(e) => e.preventDefault()}
//               >
//                 <p
//                   className='text-muted mb-3'
//                   style={{ textAlign: 'justify', userSelect: 'none' }}
//                   dangerouslySetInnerHTML={{
//                     __html: showFullContent
//                       ? content.replace(/\n/g, '<br />')
//                       : `${content
//                           .substring(0, previewLength)
//                           .replace(/\n/g, '<br />')}...`,
//                   }}
//                 />
//                 {content.length > previewLength && (
//                   <button
//                     className='btn btn-link text-primary p-0'
//                     onClick={toggleContent}
//                     style={{ textDecoration: 'none' }}
//                   >
//                     {showFullContent ? 'Read Less' : 'Read More'}
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Course

// import { useLocation, useNavigate } from 'react-router-dom'
// import bannerImg from '../Assets/Assests/view-futuristic-robot-school-environment 2.png'
// import Navbar from './Navbar'
// import { FaArrowLeft, FaCoins } from 'react-icons/fa'
// import { useEffect, useState } from 'react'
// import axios from 'axios'

// const Course = () => {
//   const navigate = useNavigate()
//   const location = useLocation()
//   const course = location.state?.section || {}
//   const [loading, setLoading] = useState(false)
//   const [showFullContent, setShowFullContent] = useState(false)
//   const [chapters, setChapters] = useState([])
//   const content = course.content || 'No content available.'
//   const previewLength = 500

//   const toggleContent = () => setShowFullContent(!showFullContent)
//   const handleBack = () => navigate(-1)

//   useEffect(() => {
//     // Disable print screen, ctrl+u, ctrl+s
//     const handleKeyDown = (event) => {
//       if (
//         event.key === 'PrintScreen' ||
//         (event.ctrlKey && ['u', 's'].includes(event.key))
//       ) {
//         event.preventDefault()
//         alert('This action is disabled.')
//       }
//     }

//     // Disable right click
//     const handleContextMenu = (event) => event.preventDefault()

//     document.addEventListener('keydown', handleKeyDown)
//     document.addEventListener('contextmenu', handleContextMenu)

//     return () => {
//       document.removeEventListener('keydown', handleKeyDown)
//       document.removeEventListener('contextmenu', handleContextMenu)
//     }
//   }, [])

//   // // 🔥 Fetch chapters from API
//   // useEffect(() => {
//   //   const fetchChapters = async () => {
//   //     try {
//   //       setLoading(true)
//   //       const res = await axios.get(
//   //         `https://aimuseumbackend.teslabird.com/membership/chapters/?module_id=${course.id}`,
//   //         {
//   //           headers: {
//   //             Authorization: `Bearer ${localStorage.getItem('access')}`,
//   //             'Content-Type': 'application/json',
//   //           },
//   //         }
//   //       )
//   //       setChapters(res.data)
//   //     } catch (err) {
//   //       console.error('Failed to fetch chapters:', err)
//   //     } finally {
//   //       setLoading(false)
//   //     }
//   //   }

//   //   if (course.id) {
//   //     fetchChapters()
//   //   }
//   // }, [course.id])

//   useEffect(() => {
//     if (!course?.id) return

//     const fetchChapters = async () => {
//       setLoading(true)
//       try {
//         const { data } = await axios.get(
//           `https://aimuseumbackend.teslabird.com/membership/chapters/`,
//           {
//             params: { module_id: course.id },
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem('access')}`,
//               'Content-Type': 'application/json',
//             },
//           }
//         )
//         setChapters(data)
//       } catch (error) {
//         console.error('Failed to fetch chapters:', error)
//       } finally {
//         setLoading(false)
//       }
//     }

//     fetchChapters()
//   }, [course?.id])

//   return (
//     <>
//       <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
//         <Navbar />

//         <div className='container py-2'>
//           <button
//             className='btn text-primary border-0 d-inline-fle
//             x align-items-center mb-4'
//             onClick={handleBack}
//           >
//             <FaArrowLeft className='me-2' /> Back
//           </button>

//           <div className='row'>
//             <div className='col-lg-8 mx-auto'>
//               <div className='mb-4'>
//                 <div className='d-flex align-items-baseline'>
//                   <h1 className='display-4 fw-bold me-3'>
//                     {course.moduleNumber}
//                   </h1>
//                   <div
//                     className='w-100 position-relative'
//                     style={{ height: '8px', top: '-10px' }}
//                   >
//                     <div
//                       className='rounded'
//                       style={{
//                         width: '50%',
//                         height: '100%',
//                         background: ' #69C969',
//                       }}
//                     ></div>
//                   </div>
//                 </div>
//                 <h2 className='mt-2 mb-4 fw-bold'>
//                   {course.module || 'Mental & Physical Well-being'}
//                 </h2>
//               </div>

//               {/* ✅ Dynamic Chapters List */}
//               <div className='mb-5'>
//                 <h5 className='fw-bold mb-3'>Chapters:</h5>
//                 {loading ? (
//                   <div className='text-center'>
//                     <div className='spinner-border text-primary' role='status'>
//                       <span className='visually-hidden'>Loading...</span>
//                     </div>
//                   </div>
//                 ) : chapters.length > 0 ? (
//                   <ol className='list-group list-group-numbered border-0'>
//                     {chapters.map((chapter, index) => (
//                       <li
//                         key={chapter.id}
//                         className='list-group-item border-0 ps-0 py-2 fw-bold'
//                         style={{ cursor: 'pointer' }}
//                         onClick={() =>
//                           navigate(`/chapter/${chapter.id}`, {
//                             state: {
//                               chapter: {
//                                 ...chapter,
//                                 chapter_number: index + 1,
//                               },
//                             }, // 👈 Add chapter_number here
//                           })
//                         }
//                       >
//                         {chapter.chapter_name}
//                       </li>
//                     ))}
//                   </ol>
//                 ) : (
//                   <p className='text-muted'>No chapters found.</p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <style jsx>{`
//         .list-group-item {
//           transition: background-color 0.2s ease, color 0.2s ease;/
//         }

//         .list-group-item:hover {
//           color: #1669c9;
//         }
//       `}</style>
//     </>
//   )
// }

// export default Course

// import { useState, useEffect } from 'react'
// import { useNavigate, useLocation } from 'react-router-dom'
// import axios from 'axios'
// import { FaArrowLeft } from 'react-icons/fa'
// import Navbar from './Navbar' // adjust path as needed

// const Course = () => {
//   const navigate = useNavigate()
//   const { state } = useLocation()
//   const course = state?.section || {}

//   const [loading, setLoading] = useState(false)
//   const [chapters, setChapters] = useState([])

//   const handleBack = () => navigate(-1)

//   const fetchChapters = async () => {
//     if (!course?.id) return
//     setLoading(true)
//     try {
//       const { data } = await axios.get(
//         'https://aimuseumbackend.teslabird.com/membership/chapters/',
//         {
//           params: { module_id: course.id },
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('access')}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       )
//       setChapters(data)
//     } catch (error) {
//       console.error('Failed to fetch chapters:', error)
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     fetchChapters()

//     const handleKeyDown = (e) => {
//       if (
//         e.key === 'PrintScreen' ||
//         (e.ctrlKey && ['u', 's'].includes(e.key.toLowerCase()))
//       ) {
//         e.preventDefault()
//         alert('This action is disabled.')
//       }
//     }

//     const handleContextMenu = (e) => e.preventDefault()

//     document.addEventListener('keydown', handleKeyDown)
//     document.addEventListener('contextmenu', handleContextMenu)

//     return () => {
//       document.removeEventListener('keydown', handleKeyDown)
//       document.removeEventListener('contextmenu', handleContextMenu)
//     }
//   }, [course?.id])

//   return (
//     <>
//       <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
//         <Navbar />

//         <div className='container py-2'>
//           <button
//             className='btn text-primary border-0 d-inline-flex align-items-center mb-4'
//             onClick={handleBack}
//           >
//             <FaArrowLeft className='me-2' /> Back
//           </button>

//           <div className='row'>
//             <div className='col-lg-8 mx-auto'>
//               <div className='mb-4'>
//                 <div className='d-flex align-items-baseline'>
//                   <h1 className='display-4 fw-bold me-3'>
//                     {course.moduleNumber || ''}
//                   </h1>
//                   <div
//                     className='w-100 position-relative'
//                     style={{ height: '8px', top: '-10px' }}
//                   >
//                     <div
//                       className='rounded'
//                       style={{
//                         width: '50%',
//                         height: '100%',
//                         background: '#69C969',
//                       }}
//                     />
//                   </div>
//                 </div>
//                 <h2 className='mt-2 mb-4 fw-bold'>
//                   {course.module || 'Mental & Physical Well-being'}
//                 </h2>
//               </div>

//               <div className='mb-5'>
//                 <h5 className='fw-bold mb-3'>Chapters:</h5>
//                 {loading ? (
//                   <div className='text-center'>
//                     <div className='spinner-border text-primary' role='status'>
//                       <span className='visually-hidden'>Loading...</span>
//                     </div>
//                   </div>
//                 ) : chapters.length > 0 ? (
//                   <ol className='list-group list-group-numbered border-0'>
//                     {chapters.map((chapter, index) => (
//                       <li
//                         key={chapter.id}
//                         className='list-group-item border-0 ps-0 py-2 fw-bold'
//                         style={{ cursor: 'pointer' }}
//                         onClick={() =>
//                           navigate(`/chapter/${chapter.id}`, {
//                             state: {
//                               chapter: {
//                                 ...chapter,
//                                 chapter_number: index + 1,
//                               },
//                             },
//                           })
//                         }
//                       >
//                         {chapter.chapter_name}
//                       </li>
//                     ))}
//                   </ol>
//                 ) : (
//                   <p className='text-muted'>No chapters found.</p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* 👇 Scoped Styles */}
//       <style jsx>{`
//         .list-group-item {
//           transition: background-color 0.2s ease, color 0.2s ease;
//         }

//         .list-group-item:hover {
//           color: #1669c9;
//         }
//       `}</style>
//     </>
//   )
// }

// export default Course

import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import { FaArrowLeft } from 'react-icons/fa'
import Navbar from './Navbar' // adjust path as needed

const Course = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const course = state?.section || {}

  const [loading, setLoading] = useState(false)
  const [chapters, setChapters] = useState([])

  const handleBack = () => navigate(-1)

  // const fetchChapters = async () => {
  //   if (!course?.id) return
  //   setLoading(true)
  //   try {
  //     const { data } = await axios.get(
  //       'https://aimuseumbackend.teslabird.com/membership/chapters/',
  //       {
  //         params: { module_id: course.id },
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem('access')}`,
  //           'Content-Type': 'application/json',
  //         },
  //       }
  //     )
  //     setChapters(data)
  //   } catch (error) {
  //     console.error('Failed to fetch chapters:', error)
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  const fetchChapters = async () => {
    if (!course?.id) return

    const cachedData = sessionStorage.getItem(`chapters_${course.id}`)
    if (cachedData) {
      setChapters(JSON.parse(cachedData))
      return
    }

    setLoading(true)
    try {
      const { data } = await axios.get(
        'https://aimuseumbackend.teslabird.com/membership/chapters/',
        {
          params: { module_id: course.id },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access')}`,
            'Content-Type': 'application/json',
          },
        }
      )
      setChapters(data)
      sessionStorage.setItem(`chapters_${course.id}`, JSON.stringify(data))
    } catch (error) {
      console.error('Failed to fetch chapters:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    let didCall = false

    if (course?.id && !didCall) {
      fetchChapters()
      didCall = true
    }

    const handleKeyDown = (e) => {
      if (
        e.key === 'PrintScreen' ||
        (e.ctrlKey && ['u', 's'].includes(e.key.toLowerCase()))
      ) {
        e.preventDefault()
        alert('This action is disabled.')
      }
    }

    const handleContextMenu = (e) => e.preventDefault()

    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('contextmenu', handleContextMenu)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('contextmenu', handleContextMenu)
    }
  }, [course?.id])

  return (
    <>
      <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
        <Navbar />

        <div className='container py-2'>
          <button
            className='btn text-primary border-0 d-inline-flex align-items-center mb-4'
            onClick={handleBack}
          >
            <FaArrowLeft className='me-2' /> Back
          </button>

          <div className='row'>
            <div className='col-lg-8 mx-auto'>
              <div className='mb-4'>
                <div className='d-flex align-items-baseline'>
                  <h1 className='display-4 fw-bold me-3'>
                    {course.moduleNumber || ''}
                  </h1>
                  <div
                    className='w-100 position-relative'
                    style={{ height: '8px', top: '-10px' }}
                  >
                    <div
                      className='rounded'
                      style={{
                        width: '50%',
                        height: '100%',
                        background: '#69C969',
                      }}
                    />
                  </div>
                </div>
                <h2 className='mt-2 mb-4 fw-bold'>
                  {course.module || 'Mental & Physical Well-being'}
                </h2>
              </div>

              <div className='mb-5'>
                <h5 className='fw-bold mb-3'>Chapters:</h5>
                {loading ? (
                  <div className='text-center'>
                    <div className='spinner-border text-primary' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </div>
                  </div>
                ) : chapters.length > 0 ? (
                  <ol className='list-group list-group-numbered border-0'>
                    {chapters.map((chapter, index) => (
                      <li
                        key={chapter.id}
                        className='list-group-item border-0 ps-0 py-2 fw-bold'
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                          navigate(`/chapter/${chapter.id}`, {
                            state: {
                              chapter: {
                                ...chapter,
                                chapter_number: index + 1,
                              },
                            },
                          })
                        }
                      >
                        {chapter.chapter_name}
                      </li>
                    ))}
                  </ol>
                ) : (
                  <p className='text-muted'>No chapters found.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 👇 Scoped Styles */}
      <style jsx>{`
        .list-group-item {
          transition: background-color 0.2s ease, color 0.2s ease;
        }

        .list-group-item:hover {
          color: #1669c9;
        }
      `}</style>
    </>
  )
}

export default Course
